/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types'
import React, { useState, useEffect, useCallback } from 'react'
import MetaTags from 'react-meta-tags'
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import { toast } from 'react-toastify'
import { MoreHorizontal, Trash, ExternalLink } from 'react-feather'

import { Loading } from '../../components/Loading'
import Services from '../../services/auth'
import { formatDateT } from '../../util/string'
import './styles.css'

import { ModalAccess } from '../../components/modalAccess'

const AccessRowActions = ({ row, onOpenLink, onDelete }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className="security-access-actions d-flex align-items-center justify-content-end gap-2">
      <Button
        type="button"
        color="link"
        className="security-access-link-btn p-1"
        onClick={() => onOpenLink(row)}
        title="Abrir painel de conexão"
      >
        <ExternalLink size={18} className="text-primary" />
      </Button>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)}>
        <DropdownToggle
          caret={false}
          className="btn btn-sm btn-outline-secondary border-0 security-access-kebab"
          tag="button"
          type="button"
        >
          <MoreHorizontal size={18} />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end shadow-sm">
          <DropdownItem
            onClick={() => {
              setOpen(false)
              onDelete(row)
            }}
            className="text-danger"
          >
            <Trash size={14} className="me-2 align-middle" />
            Excluir acesso
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

const Security = () => {
  const { listAcess } = Services
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [showModalGrupo, setShowModalGrupo] = useState(false)

  const handleClose = () => {
    setLoading(false)
  }

  const loadUsers = useCallback(async () => {
    setLoading(true)

    const response = await listAcess()

    if (response.status === 200) {
      const responseData = response?.data?.data
      const formattedData = responseData.map((item) => ({
        ...item,
        created_at: formatDateT(item.created_at)
      }))

      setRows(formattedData)
      setLoading(false)
    } else {
      toast.error(response)
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadUsers()
  }, [loadUsers])

  const handleCreateLinkInstance = (row) => {
    if (row?.checkApi) {
      const Url = `${process.env.REACT_APP_SITE_URL}ZapMaisDetails/${row?.id}`
      window.open(Url, '_blank')
    } else {
      const idZapi = row?.id_zapi
      const tokenZapi = row?.token_zapi
      const Url = `${process.env.REACT_APP_SITE_URL}ZApiDetails/${idZapi}/${tokenZapi}`
      window.open(Url, '_blank')
    }
  }

  const handlerCriarGrupo = async () => {
    setShowModalGrupo(true)
  }

  const onCloseModalGrupo = () => {
    setShowModalGrupo(false)
  }

  const onDeleteGrupo = async (row) => {
    const response = await Services.deleteAcess({ id: row?.id })
    if (response.status === 200) {
      toast.success('Acesso excluído com sucesso!')
      loadUsers()
    }
  }

  return (
    <React.Fragment>
      {loading && <Loading open={loading} handleClose={handleClose} />}

      <div className="page-content">
        <MetaTags>
          <title>Nível de Acesso | Zap+</title>
        </MetaTags>
        <Container fluid className="security-access-page">
          <Row className="security-access-hero align-items-start align-items-md-center mb-4">
            <Col xs={12} md>
              <h4 className="security-access-title mb-1">Nível de acesso</h4>
              <p className="text-muted mb-0 security-access-subtitle">
                Gerencie quem pode acessar suas instâncias e abrir o painel de
                conexão.
              </p>
            </Col>
            <Col xs={12} md="auto" className="mt-3 mt-md-0">
              <Button
                type="button"
                className="newBg px-4"
                onClick={() => handlerCriarGrupo()}
              >
                Liberar acesso
              </Button>
            </Col>
          </Row>

          <Card className="security-access-card border-0 shadow-sm">
            <CardBody className="p-0">
              <div className="security-access-card-head px-4 py-3">
                <div>
                  <h5 className="mb-0 fw-semibold">Meus acessos</h5>
                  <small className="text-muted">
                    Lista de usuários com permissão nesta conta.
                  </small>
                </div>
              </div>

              {rows?.length > 0 ? (
                <div className="table-responsive security-access-table-wrap">
                  <Table
                    hover
                    className="security-access-table mb-0 align-middle"
                  >
                    <thead>
                      <tr>
                        <th scope="col" className="ps-4">
                          Cód.
                        </th>
                        <th scope="col">Usuário</th>
                        <th scope="col">Status</th>
                        <th scope="col">Acesso (instância)</th>
                        <th scope="col">Data</th>
                        <th
                          scope="col"
                          className="text-end pe-4"
                          style={{ width: '120px' }}
                        >
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row) => (
                        <tr key={row.id}>
                          <td className="ps-4 text-muted">{row.id}</td>
                          <td className="fw-medium">{row.name}</td>
                          <td>
                            {row.status ? (
                              <Badge color="success" pill className="px-3">
                                Ativo
                              </Badge>
                            ) : (
                              <Badge color="secondary" pill className="px-3">
                                Inativo
                              </Badge>
                            )}
                          </td>
                          <td>
                            <span
                              className="d-inline-block text-truncate security-access-cell-inst"
                              title={row.instancia_name || '—'}
                            >
                              {row.instancia_name || '—'}
                            </span>
                          </td>
                          <td className="text-muted small">{row.created_at}</td>
                          <td className="text-end pe-4">
                            <AccessRowActions
                              row={row}
                              onOpenLink={handleCreateLinkInstance}
                              onDelete={onDeleteGrupo}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="security-access-empty text-center py-5 px-4">
                  <p className="text-muted mb-3 mb-md-0">
                    Nenhum acesso liberado ainda. Use &quot;Liberar acesso&quot;
                    para adicionar um usuário.
                  </p>
                </div>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
      <ModalAccess
        onClose={onCloseModalGrupo}
        loadUsers={loadUsers}
        showModal={showModalGrupo}
      />
    </React.Fragment>
  )
}

Security.propTypes = {
  t: PropTypes.any
}

export default Security
